type OCRStatusBadgeProps = {
  status?: CharityFileAttachmentType['ocrStatus']
}

const ocrStatusClassMap: Record<NonNullable<CharityFileAttachmentType['ocrStatus']>, string> = {
  MATCH: 'tag bg-green-light text-green-dark',
  SKIPPED: 'tag tag-orange',
  MISMATCH: 'tag bg-red text-white'
}

const normalizeOcrStatus = (value: string) => value.replace(/\(.*\)$/, '')

export const OCRStatusBadge = ({ status }: OCRStatusBadgeProps) => {
  if (!status) {
    return null
  }

  const normalizedOcrStatus = normalizeOcrStatus(status)
  const statusClass = ocrStatusClassMap[normalizedOcrStatus as keyof typeof ocrStatusClassMap]

  return <span className={`m-md inline-block ${statusClass}`}>OCR {normalizedOcrStatus}</span>
}
